import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Grid, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { agreementNameValidator } from '~/business-logic/validators';
import { AgreementName } from '~/components/AgreementStudioPage/AgreementName/AgreementName';
import { TemplateVariablesProvider } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import { VariableInlineRenderer } from '~/components/AgreementStudioPage/TemplateVariables/VariableInlineRenderer/VariableInlineRenderer';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getAgreementName } from '../EditDraftsTable.utils';
import { PersistTemplateVariableValues } from '../PersistTemplateVariableValues';
import styles from './Cells.module.scss';
const EMPTY_RICH_TEXT_FIELDS = [];
export const GetAgreementNameModalContentTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AgreementNameModalContentTID: {
                Grid: 'agreement-name-modal-grid',
                AgreementName: 'edit-agreement-name-modal'
            }
        }
    });
export const GetAgreementNameCellTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AgreementNameCellTID: {
                Cell: (index)=>"edit-agreement-name-".concat(index),
                Name: (index)=>"agreement-name-".concat(index),
                Modal: 'edit-agreement-name-modal'
            }
        }
    });
export const AgreementNameModalContent = (param)=>{
    let { draft, setDraft, contact, worksAt } = param;
    const { t: cellsTexts } = useLocaleKeys('pages.draftsDashboard.cells');
    const { AgreementNameModalContentTID } = useMemo(()=>GetAgreementNameModalContentTID(), []);
    const textFields = useMemo(()=>[
            draft.title()
        ], [
        draft
    ]);
    return /*#__PURE__*/ _jsxs(TemplateVariablesProvider, {
        contact: contact,
        worksAt: worksAt,
        agreementName: draft.title(),
        effectiveDate: draft.effectiveDateAsDate(),
        initialTemplateVariableValues: draft.templateVariableValues(),
        textFields: textFields,
        richTextFields: EMPTY_RICH_TEXT_FIELDS,
        children: [
            /*#__PURE__*/ _jsx(PersistTemplateVariableValues, {
                setDraft: setDraft
            }),
            /*#__PURE__*/ _jsx(Grid, {
                align: "center",
                className: styles.agreementName,
                testId: AgreementNameModalContentTID.Grid(),
                children: /*#__PURE__*/ _jsx(AgreementName, {
                    agreementTitle: draft.title(),
                    setAgreementTitle: (title)=>setDraft((prev)=>prev.setTitle(title)),
                    showWarning: true,
                    setAgreementTitleValid: ()=>{},
                    label: cellsTexts.agreementName(),
                    testId: AgreementNameModalContentTID.AgreementName(),
                    fullWidth: true
                })
            })
        ]
    });
};
export default function AgreementNameCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip, contact, worksAt } = param;
    const { t: cellsTexts } = useLocaleKeys('pages.draftsDashboard.cells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const { AgreementNameCellTID } = useMemo(()=>GetAgreementNameCellTID(), []);
    const onClick = ()=>onOpenModal({
            shouldSubmit: async (draft)=>Promise.resolve(agreementNameValidator(draft.title()) === true),
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: cellsTexts.agreementName(),
                    testId: AgreementNameCellTID.Modal(),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AgreementNameModalContent, {
                        draft: draft,
                        setDraft: setDraft,
                        contact: contact,
                        worksAt: worksAt
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AgreementNameCellTID.Cell(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: AgreementNameCellTID.Name(index),
            variant: draft.title() ? 'paragraph1' : 'paragraph2',
            skin: draft.title() ? 'standard' : 'secondary',
            children: /*#__PURE__*/ _jsx(VariableInlineRenderer, {
                text: getAgreementName(draft, editTableTexts.unnamedDraft()),
                mode: "text"
            })
        })
    });
}
